import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { getTextColor } from 'features/show-invoices/lib/getTextColor';
import { InvoiceStatus } from 'features/show-invoices/types';
import { MpText } from 'shared/ui/MpText';
import { PaymentDateContainerStyled } from './PaymentDate.styles';

interface PaymentDateProps {
	date: string;
	status: InvoiceStatus;
}

export const PaymentDate: FC<PaymentDateProps> = ({ date, status }) => {
	const { t, i18n } = useTranslation();

	const displayDate = dayjs(date).locale(i18n.language.slice(3)).format(`D MMMM YYYY`);

	return (
		<PaymentDateContainerStyled>
			<MpText size={14} style={{ color: getTextColor(status), lineHeight: `22px` }}>
				{status === 2 ? displayDate : t(`Marketplace_Pay_Until`, { date: displayDate }).toLowerCase()}
			</MpText>
		</PaymentDateContainerStyled>
	);
};
